export default __webpack_public_path__ + "static/media/Flickr_logo.da8d9dea.png";